export default __webpack_public_path__ + "static/logo.bioheizwerk-98e1583efd2ce19f35d7f17f5d9afa01.jpeg";